import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { UserGuideProvider } from "./user-guide-context.jsx";

export default function UserGuideRoot() {
  useEffect(() => {
    const rootContainer = document.querySelector(".root-container");
    if (rootContainer) {
      rootContainer.style.backgroundColor = "#fff";
    }

    return () => {
      if (rootContainer) {
        rootContainer.style.backgroundColor = "";
      }
    }
  }, [])
  return (
    <UserGuideProvider>
      <div
        style={{
          height: "100%",
          width: "100%",
          gap: "16px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ flex: 1 }}>
          <Outlet />
        </div>
      </div>
    </UserGuideProvider>
  );
}


